// Shared WebSocket reconnect/subscribe plumbing for the free public crypto
// exchanges (Coinbase/Kraken/Bybit/OKX), mirroring binance_service.js's
// createSpotWs/connectSpotWs/sendSpotWs/terminateSpotWs shape so Chart.vue's
// per-connector WS wiring looks the same for every exchange. Each exchange
// only supplies its own WS URL and subscribe/unsubscribe message builders;
// the connect/reconnect/ping bookkeeping lives here once.
export function createExchangeWs({ wsUrl, buildSubscribe, buildUnsubscribe, pingMessage, pingIntervalMs = 20000 }) {
    return {
        connection: null,
        _subscription: null,
        _attempts: 0,
        _reconnectTimer: null,
        _pingTimer: null,
        _handler: null,

        createWs() {
            this.connection = new WebSocket(wsUrl);
        },
        connectWs(onmessage, onstatus) {
            this._handler = onmessage;
            this._onstatus = onstatus;
            const connection = this.connection;
            connection.onmessage = onmessage;
            connection.onopen = () => {
                this._onstatus?.('connected');
                this._attempts = 0;
                if (this._subscription) connection.send(this._subscription);
                if (pingMessage) {
                    clearInterval(this._pingTimer);
                    this._pingTimer = setInterval(() => {
                        if (connection.readyState === WebSocket.OPEN) {
                            try { connection.send(pingMessage); } catch (_) {}
                        }
                    }, pingIntervalMs);
                }
            };
            connection.onclose = () => {
                if (this.connection !== connection) return;
                this._onstatus?.('reconnecting');
                clearInterval(this._pingTimer);
                const delay = Math.min(1000 * 2 ** (this._attempts || 0), 30000);
                this._attempts = (this._attempts || 0) + 1;
                clearTimeout(this._reconnectTimer);
                this._reconnectTimer = setTimeout(() => {
                    if (this.connection !== connection) return;
                    this.createWs();
                    this.connectWs(this._handler, this._onstatus);
                }, delay);
            };
        },
        subscribe(symbol) {
            const message = buildSubscribe([symbol]);
            this._subscription = message;
            const connection = this.connection;
            if (connection && connection.readyState === WebSocket.OPEN) connection.send(message);
        },
        unsubscribe(symbol) {
            this._subscription = null;
            const connection = this.connection;
            if (connection && connection.readyState === WebSocket.OPEN && buildUnsubscribe) {
                connection.send(buildUnsubscribe([symbol]));
            }
        },
        destroyWs() {
            clearTimeout(this._reconnectTimer);
            clearInterval(this._pingTimer);
            this._subscription = null;
            this._attempts = 0;
            if (this.connection) {
                this.connection.onclose = null;
                this.connection.close();
                this.connection = null;
            }
        },
    };
}
